import { Component, OnInit } from '@angular/core';
import { FeatureFlagConstant } from '@fp/constant/feature-flag-constants';
import { FeatureFlagService } from '@fp/services';

@Component({
  selector: 'member-registration-wrapper',
  templateUrl: './member-registration-wrapper.component.html',
})
export class MemberRegistrationWrapperComponent implements OnInit {
  isNewMemberConversionEnabled: boolean = false;

  constructor(private readonly featureFlagService: FeatureFlagService) {}

  ngOnInit(): void {
    this.featureFlagService.isFeatureEnabled(FeatureFlagConstant.NEW_MEMBER_CONVERSION).then((enabled) => {
      this.isNewMemberConversionEnabled = enabled;
    });
  }
}
